import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadFilesService {
  private baseUrl = 'https://plateforme.educanet.pro';

  constructor(private http: HttpClient) {}
  
  downloadFile(path: string, filename: string): Observable<Blob> {
    console.log('DownloadFilesService.downloadFile called with path:', path);
    
    let fullUrl = path;
    
    // Replace incorrect domain with correct one
    if (fullUrl.includes('parent2026.educanet.pro')) {
      fullUrl = fullUrl.replace('https://parent2026.educanet.pro', this.baseUrl);
      console.log('Replaced domain, new URL:', fullUrl);
    }
    
    // If path is relative (doesn't start with http), construct full URL
    if (!fullUrl.startsWith('http')) {
      // Remove leading slash if present
      const cleanPath = fullUrl.startsWith('/') ? fullUrl.substring(1) : fullUrl;
      fullUrl = `${this.baseUrl}/${cleanPath}`;
    }
    
    // Only add .pdf extension if the URL doesn't already end with a file extension
    if (!(/\.\w+$/.test(fullUrl))) {
      fullUrl += '.pdf';
    }
    
    console.log('Final URL for download:', fullUrl);
    
    return this.http.get(fullUrl, { responseType: 'blob' });
  }
}
